import React, { useContext, useState} from "react";
import { ContextProvider } from "../../App"

import TextField from "./TextField.jsx";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios"

import toast, { Toaster } from "react-hot-toast";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory} from "react-router-dom"

// import ReactDom to create react portals
import ReactDOM from "react-dom";

function OrderCompletionFormModal({
  closeOrderCompletionModal,
  orderFormModal,
}) {

  const [orderLoading, setOrderLoading] = useState(false)
  const { cartState, cartDispatch } = useContext(ContextProvider)
  const history = useHistory()

  const validate = Yup.object({
    schoolName: Yup.string()
      .min(3, "Must be 3 characters or more")
      .required("School Name is Required"),
    kid: Yup.string()
      .min(3, "Must be 3 characters or more")
      .required("Kid Name is Required"),
    parentName: Yup.string()
      .min(3, "Must be 3 characters or more")
      .required("Parent Name is Required"),
    parentMobile: Yup.number()
      .required("Phone Number is Required")
      .positive("Mobile Number cannot be Negative")
      .integer("Mobile Number should be Number"),
    parentEmail: Yup.string()
      .email("Invalid email address")
      .required("Parent Email is Required"),
  });

  const payNow = async (values, onSubmitProps) => {
    setOrderLoading(true)
    cartDispatch({ type: "PAY_NOW", payload: values })

  try {
    const response = await axios.post("/api/v1/orders", cartState.order)
    console.log(response)
    if (response.data.status === true) {
      setOrderLoading(false)
      closeOrderCompletionModal()
      onSubmitProps.resetForm()
      toast.success("Order Successfully Created", {
        duration: 3000,
        position: "top-left",
      })
      setTimeout(() => {
        history.push("/food/order-summery")
      }, 1500);
    }
  } catch (error) {
    setOrderLoading(false)
    console.log("Error while creating order ! ", error.response.data.message)
    toast.error(error.response.data.message,{
      duration: 3000,
      position: "top-left",
    })
  }
  };

  return ReactDOM.createPortal(
    // react portals for implement child outside the root id
    <>
      <Toaster/>
      <Formik
        initialValues={{
          schoolName: "",
          kid: "",
          parentName: "",
          parentMobile: "",
          parentEmail: "",
        }}
        validationSchema={validate}
        onSubmit={(values, onSubmitProps) => {
          payNow(values, onSubmitProps);
        }}
      >
        {(formik) => (
          <>
            <div
              className={
                orderFormModal
                  ? "select_menu_backdrop_active"
                  : "select_menu_backdrop_inactive"
              }
            ></div>
            <div
              className={
                orderFormModal
                  ? "order_completion_form_container"
                  : "order_completion_form_container_close"
              }
            >
              <Form>
                <div className="modal_header">
                  <p>Fill the form to Complete the Order</p>
                  <p>
                    <i
                      className="far fa-times-circle"
                      style={{ cursor: "pointer" }}
                      onClick={closeOrderCompletionModal}
                    ></i>
                  </p>
                </div>
                <div className="form_container">
                  <TextField
                    type="text"
                    placeholder="Enter a Delivery Address"
                    label="Delivery School / Kindergardern"
                    name="schoolName"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="text"
                    placeholder="Enter your kids name and ID"
                    label="Kid Name & ID"
                    name="kid"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="text"
                    placeholder="Enter a Parent Name"
                    label="Parents Name"
                    name="parentName"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="text"
                    placeholder="Parent Mobile"
                    label="Enter a Parent Mobile Number"
                    name="parentMobile"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="text"
                    placeholder="Enter a Parent Email"
                    label="Parent Email"
                    name="parentEmail"
                    autoComplete="off"
                    className="form_input"
                  />
                  <div className="modal_footer">
                    <button
                      type="submit"
                      className="selection_modal_footer_cancel_btn"
                      style={{ fontWeight: "normal" }}
                      onClick={closeOrderCompletionModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="selection_modal_footer_btn"
                      disabled={orderLoading ? true : false}
                      style={{
                        backgroundColor: "#FBA922",
                        color: "#fff",
                        fontWeight: "normal",
                      }}
                    >
                     {orderLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "row",
                        }}
                      >
                        <ClipLoader
                          color="#fff"
                          loading={orderLoading}
                          speedMultiplier="1.8"
                          size={20}
                          style={{ marginRight: ".3rem" }}
                        />{" "}
                      </div>
                    ) : (
                      "PAY NOW"
                    )}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </>
        )}
      </Formik>
    </>,
    document.getElementById("auth-portal-root") // another root id
  );
}

export default OrderCompletionFormModal;
